import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latest = [...comics].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-page">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">
              <i className="ri-timer-flash-line"></i> 最新更新
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              热门连载 <span className="text-accent-500">持续更新中</span>
            </h2>
          </div>
          <p className="text-foreground-500 text-sm">每日同步更新 · 不漏掉任何一话</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.slice(0, 8).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute top-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
                  comic.status === "连载中"
                    ? "bg-accent-500/90 text-background-50"
                    : "bg-foreground-700/80 text-background-50"
                }`}>
                  {comic.status}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent h-16"></div>
                <span className="absolute bottom-2 left-2 text-background-50/80 text-[10px] font-medium">
                  ★ {comic.rating}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">{comic.title}</h3>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="text-xs text-foreground-600">{comic.author}</span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{comic.latestChapter}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/lianai"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors"
          >
            查看更多作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}